import { render, staticRenderFns } from "./VenuePanicLoader.vue?vue&type=template&id=5887257f"
import script from "./VenuePanicLoader.vue?vue&type=script&lang=ts"
export * from "./VenuePanicLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports